/**
 * GET `admin/reports/clinics/:id/doctors` — отчёт по врачам выбранной
 * клиники: приёмы, начислено/оплачено/долг, средний чек.
 */

import {apiEnabled, http} from '@services/utils';

import {MOCK_DOCTOR_ROWS} from '../mocks';
import {arr, asNum, asObj, asStr, type Raw, toSom} from '../raw.utils';
import type {DoctorReportRow, ReportPeriod} from '../types';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const getClinicDoctors = async (
  clinicId: string,
  period: ReportPeriod,
): Promise<DoctorReportRow[]> => {
  if (!apiEnabled) {
    await sleep(340);
    return MOCK_DOCTOR_ROWS.map((r) => ({...r}));
  }

  const raw = await http<Raw>(`admin/reports/clinics/${encodeURIComponent(clinicId)}/doctors`, {
    params: {period},
    skipCaseConversion: true,
  });
  return arr(raw.rows).map((v) => {
    const r = asObj(v);
    return {
      membershipId: asStr(r.membershipId),
      fullName: asStr(r.fullName),
      specializationName:
        typeof r.specializationName === 'string' && r.specializationName !== ''
          ? r.specializationName
          : '—',
      appointments: asNum(r.appointments),
      completed: asNum(r.completed),
      cancelled: asNum(r.cancelled),
      charged: toSom(r.chargedTiyin),
      paid: toSom(r.paidTiyin),
      debt: toSom(r.debtTiyin),
      averageCheck: toSom(r.averageCheckTiyin),
    };
  });
};
